import { Module } from 'vuex'

export interface InsuranceStoreState {
  aliveIncludeItem: string[]
  priceDetailItemChangekey: number
}

const insuranceListName = 'insurance-jijia-insurance-list'
const insuranceRefundName = 'insurance-service-jijia-order-refund'
const insuranceFormPageName = 'insurance-jijia-insurance-form-page'

function addKeepAliveItem(state: InsuranceStoreState, pageName: string) {
  if (state.aliveIncludeItem.indexOf(pageName) !== -1) {
    return
  }
  state.aliveIncludeItem = state.aliveIncludeItem.concat(pageName)
}
function removeKeepAliveItem(state: InsuranceStoreState, pageName: string) {
  state.aliveIncludeItem = state.aliveIncludeItem.filter((item) => item !== pageName)
}
const InsranceStore: Module<InsuranceStoreState, any> = {
  namespaced: true,
  state: function () {
    return {
      aliveIncludeItem: ['insurance-jijia-device-select', 'insurance-jijia-insurance-introduce'],
      priceDetailItemChangekey: 0,
    }
  },
  mutations: {
    addInsuranceListKeepAlive(state) {
      addKeepAliveItem(state, insuranceListName)
    },
    removeInsuranceListKeepAlive(state) {
      removeKeepAliveItem(state, insuranceListName)
    },
    addInsuranceRefundKeepAlive(state) {
      addKeepAliveItem(state, insuranceRefundName)
    },
    removeInsuranceRefundKeepAlive(state) {
      removeKeepAliveItem(state, insuranceRefundName)
    },
    addInsuranceFormPageKeepAlive(state) {
      addKeepAliveItem(state, insuranceFormPageName)
    },
    removeInsuranceFormPageKeepAlive(state) {
      removeKeepAliveItem(state, insuranceFormPageName)
    },
    updatePriceDetailItemChangeKey(state) {
      state.priceDetailItemChangekey += 1
    },
  },
}

export default InsranceStore
